import { InfoFirmaVO } from "@app/shared/vo/info-firmaVO";

export class ControllaFirmaVO {
  dataVerifica: number;

  statoVerifica: boolean;

  info: InfoFirmaVO[];

  errorCode: string;
}
